import { create } from "zustand";

interface NavigationGuardStore {
  isBlocking: boolean;
  unsavedPromptOpen: boolean;
  setBlocking: (blocking: boolean) => void;
  openUnsavedPrompt: () => void;
  closeUnsavedPrompt: () => void;
}

export const useNavigationGuardStore = create<NavigationGuardStore>((set) => ({
  isBlocking: false,
  unsavedPromptOpen: false,
  setBlocking: (blocking) =>
    set((state) => ({
      isBlocking: blocking,
      unsavedPromptOpen: blocking ? state.unsavedPromptOpen : false,
    })),
  openUnsavedPrompt: () => set({ unsavedPromptOpen: true }),
  closeUnsavedPrompt: () => set({ unsavedPromptOpen: false }),
}));
